// Importar clases base primero
import './core/api-client.js';
import './core/analytics.js';
import './core/validator-clases.js';
import './core/funnel-manager.js';
import './core/price-calculator.js';

// Importar utilidades
import './utils/dom-helpers.js';
import './utils/populate-provinces.js';
import './utils/tooltips.js';
import './utils/preload-assets.js';
import './utils/phone-only.js';
import './utils/numbers-only.js';
import './utils/select-choices.js';

// Importar pasos del funnel
import './steps/funnel-step-1.js';
import './steps/funnel-step-2.js';
import './steps/funnel-step-3.js';
import './steps/funnel-step-4.js';
import './steps/checkout.js';
import './steps/recovery.js';


// Inicialización global si es necesaria
document.addEventListener('DOMContentLoaded', function() {
    // Cualquier inicialización global que necesites
    // console.log('Tasaciones Plugin loaded');
    const currentStep = detectCurrentStep();

    // Inicializar tooltips globales
    if (window.TasacionesTooltips) {
        window.TasacionesTooltipsInstance = new window.TasacionesTooltips();
        window.TasacionesTooltipsInstance.init();
    }

    switch(currentStep) {
        case 1:
            new TasacionesFunnelStep1();
            break;
        case 2:
            new TasacionesFunnelStep2();
            break;
        case 3:
            new TasacionesFunnelStep3();
            break;
        case 4:
            new TasacionesFunnelStep4();
            break;
        case 5:
            new TasacionesCheckout();
            break;
        case 'recovery':
            new TasacionesRecovery();
            break;
    }
});

function detectCurrentStep() {
    // Detectar el paso actual basado en el DOM
    for (let i = 1; i <= 5; i++) {
        if (document.getElementById(`tasaciones-funnel-step-${i}`)) {
            return i;
        }
    }
    if (document.getElementById(`tasaciones-recovery-form`)) {
        return 'recovery';
    }
    return null;
}